/* eslint-disable */
import { api } from "../../axios";

export const deletePaymentTerm = async (
  token: string,
  paymentTermKey: string,
  paymentTermId: number
) => {
  const response = await api.delete(
    `bx_block_custom_packages/destroy_payment_terms/${paymentTermId}`,
    {
      data: {
        payment_term: {
          [paymentTermKey]: false
        }
      },
      headers: { token: token }
    }
  );

  return response.data;
};
